import React from 'react';
import styled from '@emotion/styled';
import { LocalItem } from '~Types';

const Wrapper = styled.div<{ last: boolean }>`
  position: relative;
  border-bottom: ${({ last }) => (!last ? 'solid 1px rgb(238, 238, 241)' : 'none')};
`;

const NameWrapper = styled.div<{ bottomOffset: boolean }>`
  display: flex;
  justify-content: space-between;
  padding: 24px 0 ${({ bottomOffset }) => (bottomOffset ? '4px' : '25px')} 0;
`;

const Name = styled.h3`
  margin: 0;
  color: rgb(33, 33, 36);
  font-family: Eina01-SemiBold;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  transition: 0.3s color, 0.3s opacity;
`;

const Variations = styled.div`
  padding: 4px 0 21px 16px;
`;

const Variation = styled.div`
  display: flex;
`;

const VariationName = styled.strong<{ removed?: boolean }>`
  flex: 1;
  padding: 0 10px 0 0;
  color: ${({ removed }) => (removed ? '#cc3333' : 'rgb(97, 97, 100)')};
  font-weight: normal;
  font-family: Eina01-Regular;
  font-size: 16px;
  line-height: 24px;
`;

interface Props {
  item: LocalItem;
  last: boolean;
}

const Item = ({ item, last }: Props) => {
  return (
    <Wrapper last={last}>
      <NameWrapper bottomOffset={!!item.variations.length}>
        <Name>{item.title}</Name>
      </NameWrapper>

      {item.variations.length || item.removedVariations.length ? (
        <Variations>
          {item.variations.map((variation) => (
            <Variation key={variation.id}>
              <VariationName>{variation.name}</VariationName>
            </Variation>
          ))}
          {item.removedVariations.map((variation) => (
            <Variation key={variation.id}>
              <VariationName removed>- {variation.name}</VariationName>
            </Variation>
          ))}
        </Variations>
      ) : null}
    </Wrapper>
  );
};

export default Item;
